import cx from "classnames";
import { forwardRef, ReactNode, useContext, useMemo } from "react";
import { SelectStateContext, SelectValue } from "react-aria-components";

import { ChevronDown } from "components/icons/generated";
import Icon from "ds/components/Icon";
import AriaButtonInput, { AriaButtonInputProps } from "ds/components/Input/AriaButtonInput";

import Box from "../Box";
import LoadingIndicator from "../LoadingIndicator";
import styles from "./styles.module.css";

export type SelectInputProps = {
  id: string;
  size: AriaButtonInputProps["size"];
  renderValue?: (item: string) => ReactNode;
  isDisabled?: boolean;
  isError?: boolean;
  isLoading?: boolean;
};

const SelectInput = forwardRef<HTMLButtonElement, SelectInputProps>(
  ({ id, isDisabled, isError, renderValue: renderValueProp, isLoading, size }, externalRef) => {
    const state = useContext(SelectStateContext);

    const renderValue = useMemo(
      () =>
        renderValueProp ||
        (() => (
          <SelectValue className={cx(styles.selectedValue, { [styles.isDisabled]: isDisabled })} />
        )),
      [renderValueProp, isDisabled]
    );
    return (
      <AriaButtonInput
        id={id}
        className={styles.inputWrapper}
        disabled={isDisabled}
        error={isError}
        size={size}
        ref={externalRef}
      >
        <Box gap="small" align="center" justify="center" fullWidth>
          {isLoading && <LoadingIndicator loading />}
          {renderValue?.(state?.selectedKey as string)}
        </Box>
        <Icon src={ChevronDown} />
      </AriaButtonInput>
    );
  }
);

SelectInput.displayName = "DS.Select.Input";

export default SelectInput;
